import script from "./ui-message-error.vue?vue&type=script&lang=ts&setup=true"
export * from "./ui-message-error.vue?vue&type=script&lang=ts&setup=true"

import "./ui-message-error.vue?vue&type=style&index=0&id=0c813125&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c813125"]])

export default __exports__